import { create } from 'zustand';

interface SidebarCollapsedState {
  isCollapsed: boolean;
  setIsCollapsed: (collapsed: boolean) => void;
}

export const useSidebarCollapsed = create<SidebarCollapsedState>((set) => ({
  isCollapsed: false,
  setIsCollapsed: (collapsed: boolean) => set({ isCollapsed: collapsed }),
}));
